import type {GlobalConfig} from "header-bidding-client-base/modules/config/domain/globalConfig";
import type {ILogger} from "header-bidding-client-base/modules/logger/domain/iLogger";

export class ConsoleLogger implements ILogger {
    public constructor(private config: GlobalConfig) {
    }

    public log(message: any): void;
    public log(...message: any[]): void;
    public log(...args: any[]): void {
        if (this.config.log_level && ['log'].includes(this.config.log_level)) {
            console.log('[HB]', ...args);
        }
    }

    public warn(message: any): void;
    public warn(...message: any[]): void;
    public warn(...args: any[]): void {
        if (this.config.log_level && ['log', 'warn'].includes(this.config.log_level)) {
            console.warn('[HB]', ...args);
        }
    }

    public error(message: any): void;
    public error(...message: any[]): void;
    public error(...args: any[]): void {
        if (this.config.log_level && ['log', 'warn', 'error'].includes(this.config.log_level)) {
            console.error('[HB]', ...args);
        }
    }
}
